module.exports = __webpack_public_path__ + "img/Claire.4aedecfe.jpeg";